var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.5 5L15.5 12L8.5 19","stroke":"currentColor","strokeWidth":"2"}));
}

ArrowRight.defaultProps = {"width":"16","height":"16","viewBox":"0 0 24 24","fill":"none"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
